import React, { FC, ChangeEvent } from 'react'
import DocumentUploadCard from './DocumentUploadCard/DocumentUploadCard'

type propTypes = {
  handleFileUpload: (value: ChangeEvent<HTMLInputElement>, doc: string) => void
  checkIfExist: (value: string) => boolean
  children: React.ReactNode
  publicAccess?: boolean
}

const PlpDocumentUpload: FC<propTypes> = ({ handleFileUpload, checkIfExist, publicAccess }) => {
  return (
    <div className='row'>
      <div className='col-sm-6 my-4'>
        <div className='step-title'>Document Upload</div>
      </div>
      <div className='col-sm-6 text-sm-end my-4'>
        <div className='step-page-number'>Page 3 of 3</div>
      </div>

      <div className={publicAccess ? 'col-md-8' : 'col-md-6'}>
        <div className='instruction'>
          Allowable upload format: png, jpg and jpeg. Maximum allowable size: 500kb
        </div>
        <div className='form-group'>
          <DocumentUploadCard
            changeHandler={(event: ChangeEvent<HTMLInputElement>, fileName: string) =>
              handleFileUpload(event, fileName)
            }
            description='Upload a Govt issued ID card (National Identity card,
                          Voters card, Nigerian International Passport or
                          Drivers license.) Please note that a expired ID will
                          not be honored.'
            name='PLP_APPLICATION_ID'
            doc='PLP_APPLICATION_ID'
            checkIfExist={(e: string) => checkIfExist(e)}
          />

          <DocumentUploadCard
            changeHandler={(event: ChangeEvent<HTMLInputElement>, fileName: string) =>
              handleFileUpload(event, fileName)
            }
            description='Upload CAC Certificate.'
            name='PLP_APPLICATION_CAC_CERTIFICATE'
            doc='PLP_APPLICATION_CAC_CERTIFICATE'
            checkIfExist={(e: string) => checkIfExist(e)}
          />

          <DocumentUploadCard
            changeHandler={(event: ChangeEvent<HTMLInputElement>, fileName: string) =>
              handleFileUpload(event, fileName)
            }
            description='Lease Agreement or Deed of Conveyance.'
            name='PLP_APPLICATION_FILLING_STATION_REAL_OWNER_LEASE_AGREEMENT'
            doc='PLP_APPLICATION_FILLING_STATION_REAL_OWNER_LEASE_AGREEMENT'
            checkIfExist={(e: string) => checkIfExist(e)}
          />

          <DocumentUploadCard
            changeHandler={(event: ChangeEvent<HTMLInputElement>, fileName: string) =>
              handleFileUpload(event, fileName)
            }
            description='Corporate bank statement for the last 6 months.'
            name='PLP_APPLICATION_COMPANY_BANK_STATEMENT_LAST_12_MONTHS'
            doc='PLP_APPLICATION_COMPANY_BANK_STATEMENT_LAST_12_MONTHS'
            checkIfExist={(e: string) => checkIfExist(e)}
          />
          <DocumentUploadCard
            changeHandler={(event: ChangeEvent<HTMLInputElement>, fileName: string) =>
              handleFileUpload(event, fileName)
            }
            description='Upload your NMDPRA License.'
            name='PLP_APPLICATION_NMDPRA_LICENSE'
            doc='PLP_APPLICATION_NMDPRA_LICENSE'
            checkIfExist={(e: string) => checkIfExist(e)}
          />
          <DocumentUploadCard
            changeHandler={(event: ChangeEvent<HTMLInputElement>, fileName: string) =>
              handleFileUpload(event, fileName)
            }
            description='Form CAC7A - Particulars of Directors OR BN Registration Form showing Proprietor/Owner.'
            name='PLP_APPLICATION_CAC_7'
            doc='PLP_APPLICATION_CAC_7'
            checkIfExist={(e: string) => checkIfExist(e)}
          />
        </div>
      </div>
    </div>
  )
}

export default PlpDocumentUpload
